<template>

  <div>

    <div class="flex justify-center" v-if="finished === false || finished === null">
      <div class="py-5">
        <button @click="shuffleDeck"
                :disabled="timerCount > 0"
                class="bg-yellow-400 shadow-lg  items-center content-center border-b-4 border-orange-500 hover:border-orange-300 hover:bg-yellow-300 text-lg font-bold rounded-full text-center font-bold py-2 px-4 text-black rounded inline-flex justify-center">
          {{ timerCount > 0 ? timerCount : "Let's Pick!" }}
        </button>
      </div>

    </div>

    <div class="py-2">
      <a-select
          v-model:value="selectedItems"
          mode="tags"
          placeholder="Type anything here for luck pick."
          style="width: 100%"
          :options="filteredOptions"
      >
      </a-select>
      <small class="font-bold">You can also insert anything you want by type + ENTER.</small>
    </div>

    <div class="flex items-center justify-around border-solid border-4 border-purple-400 px-2 py-2">
      <template v-if="localCards.length > 0">
        <transition-group :name="shuffleSpeed" tag="div" class="flex flex-wrap">
          <div v-for="(card,index) in localCards" :key="index"
               class="py-10 px-10 bg-white mr-2 mt-2 shadow-md rounded-lg"
               :class="timerCount <=0 && selectedPerson === index ? 'animate-bounce border-solid border-8 border-orange-400' : ' border-orange-400 border-4  border-dashed' "
          >
            <div>
              <label class="text-xl font-bold"
              > {{ card }}</label>
            </div>
          </div>
        </transition-group>
      </template>
      <template v-else>
        <div class="p-4 mb-2">
          <p class="text-gray-600 font-bold text-lg">🍀 Please add something to here... 🍀</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {computed, onMounted, defineComponent, ref} from 'vue';

export default {
  props: ['cards'],
  setup(props) {
    const selectedItems = ref([]);

    const filteredOptions = ref([]);

    const localCards = ref([]);
    onMounted(() => {
      props.cards.map(o => {
        filteredOptions.value.push(
            {
              value: o.name
            }
        );
      });
      props.cards.map((card) => selectedItems.value.push(card.name));

      localCards.value = [...selectedItems.value];
    });
    return {
      localCards,
      selectedItems,
      filteredOptions,
    }
  },
  mounted() {
  },
  data() {
    return {
      timerCount: 0,
      counter: 5,
      runInterval: null,
      selectedPerson: null,
      finished: null,
      shuffleSpeed: 'shuffleMedium',
      shuffleTypes: ['Slow', 'Medium', 'Fast'],
      shuffleCount: 0,
    }
  },
  created() {
  },

  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 750);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    selectedItems: function (val) {
      this.localCards = [...this.selectedItems]
    },
  },
  methods: {
    shuffleDeck() {
      this.timerCount = 3;
      this.selectedPerson = Math.floor(Math.random() * this.localCards.length);
    },
  },
  components: {},
}
</script>

<style scoped>


.shuffleSlow-move {
  transition: transform 2s;
}

.shuffleMedium-move {
  transition: transform 1s;
}

.shuffleFast-move {
  transition: transform 0.5s;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>